import routePaths from 'app/components/Router/routePaths';
import { features } from 'accessControl/features';
import {
  PagesNavIcon,
  ReviewNavIcon,
  NavConfigNavIcon,
  ApplicationNavIcon,
  ShortlistingNavIcon,
  PaymentsNavIcon,
  ProgramNavIcon,
  // LeadsNavIcon,
  ReferralsNavIcon,
  OverviewNavIcon,
  CouponsNavIcon,
  BatchesNavIcon,
  EmailsNavIcon,
  UsersNavIcon,
  SettingIcon,
  DownloadIcon,
} from 'images/navigationIcons';

// import ApplicationNavIcon from "assets/images/navigationIcons/applicationNavIcon.svg";
// import ProgramNavIcon from "assets/images/navigationIcons/programNavIcon.svg";

// Nav for entities
export const entitiesNavs = [
  {
    name: 'Overview',
    description: 'Quick start. Learn about Entities',
    svgIcon: OverviewNavIcon,
    key: 'overview',
    path: routePaths.entities__overview,
  },
  {
    name: 'Applications (Legacy)',
    description:
      'Config and Process Applications for the future students on upGrad',
    svgIcon: ApplicationNavIcon,
    key: 'applications',
    path: routePaths.applicationManagement__overview,
    feature: [features.APPLICATION_ID_CONFIG, features.APPLICATION_DUMP_CONFIG],
  },
  {
    name: 'Application Journeys',
    description:
      'Configure Application journeys for the future students on upGrad',
    svgIcon: ApplicationNavIcon,
    key: 'application-journey',
    path: routePaths.applicationFlowManagement__overview,
    feature: [
      features.CREATE_APPLICATION_JOURNEY,
      features.CLONE_APPLICATION_JOURNEY,
      features.EDIT_APPLICATION_JOURNEY,
      features.PUBLISH_APPLICATION_JOURNEY,
    ],
  },
  {
    name: 'Shortlisting',
    description: 'Config and Shortlisting the future students on upGrad',
    svgIcon: ShortlistingNavIcon,
    key: 'shortlisting',
    path: routePaths.shortlistingManagement__overview,
    feature: features.SHORTLISTING_CONFIG,
  },
  {
    name: 'Payments',
    description: 'Config and take Payment related actions on. Finance friendly',
    svgIcon: PaymentsNavIcon,
    key: 'payments',
    path: routePaths.paymentManagement__overview,
    feature: [
      features.PAYMENT_UNIVERSITY,
      features.PAYMENT_SETTLEMENT,
      features.PAYMENT_MODES,
      features.PAYMENT_INVOICE,
      features.PAYMENT_LINK,
    ],
  },
  {
    name: 'Programs',
    description: 'Identify and take actions on our core Program entities',
    svgIcon: ProgramNavIcon,
    key: 'programs',
    path: routePaths.programManagement__overview,
    feature: [features.BASE_SETUP],
  },
  {
    name: 'Emailers',
    description: 'Config Marketing emails in a jiffy',
    svgIcon: EmailsNavIcon,
    key: 'emailers',
    path: routePaths.emailManagement__overview,
    feature: features.EMAIL_CONFIG,
  },
  {
    name: 'Referrals',
    description: 'Identify and Take actions on Referral cases',
    svgIcon: ReferralsNavIcon,
    key: 'referral',
    path: routePaths.referralManagement__overview,
    feature: [features.REFERRAL_DASHBOARD, features.REFERRAL_BULK_OPERATION],
  },
  {
    name: 'Coupons',
    description: 'Take actions that help with Coupons and Scholarship',
    svgIcon: CouponsNavIcon,
    key: 'coupons',
    path: routePaths.couponManagement__overview,
    feature: [
      features.SCHOLARSHIP_COUPON_APPLY,
      features.SCHOLARSHIP_BUDGET_ALLOCATION,
    ],
  },
  // {
  // 	name: "Leads",
  // 	description: "Identify actions that drive users to convert/retain",
  // 	svgIcon: LeadsNavIcon,
  // 	key: "leads",
  // 	path: "",
  // 	feature: "",
  // },
  {
    name: 'Downloads',
    key: 'downloads',
    description: 'Download Applicants Data',
    svgIcon: DownloadIcon,
    path: routePaths.downloads__overview,
    feature: [features.DOWNLOAD_APP_DUMP],
  },
  {
    name: 'Configurations',
    key: 'configurations',
    description: 'Add, Update & View Configurations',
    svgIcon: SettingIcon,
    path: routePaths.configurations__overview,
    feature: [features.CONFIG_SETUP],
  },

  {
    name: 'Batches',
    key: 'batches',
    description: 'Manage Marketing Batches',
    svgIcon: BatchesNavIcon,
    path: routePaths.batchManagement__overview,
    feature: [
      features.BATCH_CREATE,
      features.BATCH_EDIT,
      features.FINANCE_BATCH_APPROVAL,
      features.ASSIGN_PROGRAM_BATCH,
    ],
  },
  {
    name: 'Refunds',
    description: 'Identify and take actions on Refund cases',
    svgIcon: ApplicationNavIcon,
    key: 'refunds',
    path: '',
    feature: [features.REFUNDS_EDIT],
  },
];

// Nav for Content
export const pageNavs = [
  {
    name: 'Pages',
    description: 'Explore our Landing Pages, create, clone and manage them',
    svgIcon: PagesNavIcon,
    key: 'pages',
    path: routePaths.pageListerPage,
    feature: features.EDIT_PAGE,
  },
  {
    name: 'Review Requests',
    description: 'Review & publish Landing Page Changes',
    svgIcon: ReviewNavIcon,
    key: 'review-requests',
    path: routePaths.reviewRequestsPage,
    feature: features.REVIEW_REQUESTS,
  },
  {
    name: 'Global Config',
    description: 'Real-time Navigation Config',
    svgIcon: NavConfigNavIcon,
    key: 'nav-config',
    path: routePaths.pageConfigPage,
    feature: features.NAVBAR_CONFIG,
  },
  {
    name: 'Program Maps',
    description: 'Program page configs',
    svgIcon: PaymentsNavIcon,
    key: 'program-map',
    path: routePaths.programMapPage,
    feature: features.NAVBAR_CONFIG,
  },
];

// Nav for Users
export const userNavs = [
  {
    name: 'Roles Management',
    description: 'Assign Roles, Teams. Belonginess',
    svgIcon: UsersNavIcon,
    key: 'roles',
    path: routePaths.roleManagement__overview,
    feature: [
      features.ROLE_ASSIGNMENT,
      features.TEAM_ASSIGNMENT,
      features.FEATURE_MAPPING,
    ],
  },
];
